// Function to set or remove the completed background color class on the body element
export const setCompletedBackgroundColor = (completed: boolean): void => {
  if (completed) {
    document.body.classList.add('completed-bg-color')
  } else {
    document.body.classList.remove('completed-bg-color')
  }
}